export default __webpack_public_path__ + "static/media/marker_with_number.fec14ff3.svg";